<template>
  <div class="containerDiv">
  <v-container >
    <h1 style="color: white">Activación y creación de contraseña - Sistema Inscora</h1>
    <v-card style="width: 60%">
      <v-card-title>
        <v-form v-model="valid">
          Ingrese su contraseña y la confirmación de la misma
          <v-text-field prepend-icon="lock" :rules="newPasswordRules" name="Nueva Contraseña" label="Nueva Contraseña" type="password" v-model="newPassword"></v-text-field>
          <v-text-field prepend-icon="lock" :rules="newPasswordRules" name="Confirme su Nueva Contraseña" label="Confirme su Nueva Contraseña"  type="password" v-model="newPasswordConfirmation" v-on:keyup.enter="changePassword"></v-text-field>
        </v-form>
      </v-card-title>
      <v-card-actions>
        <v-btn color="primary" flat  :disabled="!valid" @click="changePassword">Cambiar</v-btn>
        <v-btn color="primary" flat @click.stop="dialogPassword=false" @click="cleanPasswordChange">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        newPassword: "",
        newPasswordConfirmation: "",
        error: "",
        alert: false,
        valid: false,
        newPasswordRules: [
          v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(v) || 'La constraseña deberá ser mínimo de 8 caracteres, contener mínimo 1 letra mayúscula y 1 carácter numérico',
        ],
      };
    },
    methods:{
      changePassword () {
        if(this.checkNewPassword()){
          this.$store.dispatch('changePasswordNotSession',  {key:this.$store.state.changePassword,newPassword:this.newPassword}).then(response => {
            this.cleanPasswordChange()
          }, error => {
            this.$store.state.dialogError = true
          })
          this.dialogPassword = false
        }
      },
      checkNewPassword(){
        if(this.newPassword != this.newPasswordConfirmation){
          this.$store.state.dialogErrorMessage = "La nueva contraseña no coincide con la confirmación."
          this.$store.state.dialogError = true
          return false
        }
        return true
      },
      cleanPasswordChange(){
        this.newPassword= ""
        this.newPasswordConfirmation= ""
        this.dialogPassword= false
        this.alert= false
        this.valid= false
      }
    },
    computed : {
    },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue